import React, { ReactNode } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { Typography, Icon } from '@scale/scaleui';
import { twMerge } from 'tailwind-merge';

interface FilterComponentProps {
  children?: ReactNode;
  openRight?: boolean;
  filterMessage?: string;
}

const FilterComponent: React.FC<FilterComponentProps> = ({
  children,
  openRight = false,
  filterMessage = 'Filter',
}) => {
  const positionClass = openRight ? '' : 'right-0';

  return (
    <div>
      <Popover className="relative">
        {({ open }) => (
          <>
            <Popover.Button className="scaleui inline-flex items-center rounded border-0 font-medium focus:outline-none transition-all h-fit pr-2.5 pl-0.5 py-0.5 text-sm hover:bg-neutral-300 bg-transparent text-neutral-600 w-full">
              <div className="flex items-center justify-evenly w-full">
                <Icon icon={['far', 'filter']} variant="neutral" />
                <Typography.Paragraph2>
                  <span className="block truncate text-neutral-500">{filterMessage}</span>
                </Typography.Paragraph2>
              </div>
            </Popover.Button>
            <Transition
              show={open}
              as={React.Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Popover.Panel
                static
                className={twMerge(
                  `absolute z-10 w-[400px] py-1 mt-1 text-base rounded-lg shadow-lg bg-neutral-0 ring-1 ring-neutral-900 ring-opacity-5 focus:outline-none sm:text-sm ${positionClass}`,
                )}
              >
                <div className="flex flex-col gap-3 py-3 px-4 z-50">{children}</div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
};

export default FilterComponent;
